import React from 'react'
import moment from 'moment'
import { Input, Button } from 'semantic-ui-react'

export default class DateFields extends React.PureComponent {
  render() {
    const { loading, onSearch, onFieldChange } = this.props
    let { startFrom, endAt } = this.props

    startFrom = moment(startFrom).format('YYYY-MM-DD')
    endAt = moment(endAt).format('YYYY-MM-DD')

    return (
      <div>
        <div className="capitalize" style={{ display: 'inline-block', marginRight: 10 }}>
          From
        </div>

        <Input
          type="date"
          name="from"
          value={startFrom}
          onChange={e => onFieldChange('startFrom', e.target.value)}
        />

        <div
          className="capitalize"
          style={{ display: 'inline-block', marginLeft: 10, marginRight: 10 }}
        >
          To
        </div>

        <Input
          type="date"
          name="to"
          value={endAt}
          onChange={e => onFieldChange('endAt', e.target.value)}
        />
        <Button loading={loading} disabled={loading} onClick={onSearch} style={{ marginLeft: 10 }}>
          Search
        </Button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/drivers/fields/dateFields.js